export default function StarRatingField() {
  return null; // TODO: unimplemented method
}
